import { reactive, watch } from 'vue'

// Appearance: 'system' follows the phone, 'light'/'dark' override it (More › Appearance).
const STORAGE_KEY = 'appearance'
const darkQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null

function readPreference() {
	try {
		const value = window.localStorage.getItem(STORAGE_KEY)
		return value === 'light' || value === 'dark' ? value : 'system'
	} catch {
		return 'system'
	}
}

export const theme = reactive({
	preference: readPreference(),
	systemDark: !!darkQuery?.matches,
	get dark() {
		return this.preference === 'dark' || (this.preference === 'system' && this.systemDark)
	},
})

export function setAppearance(preference) {
	theme.preference = preference
	try {
		if (preference === 'system') window.localStorage.removeItem(STORAGE_KEY)
		else window.localStorage.setItem(STORAGE_KEY, preference)
	} catch {
		// private mode: the choice lasts for this session only
	}
}

function applyTheme() {
	const root = document.documentElement
	if (theme.preference === 'system') root.removeAttribute('data-theme')
	else root.setAttribute('data-theme', theme.preference)
	refreshStatusBarColor()
}

let statusBarToken = 'bg'

// The status bar area belongs to the top bar, so it takes the bar's color.
export function setStatusBarColor(token = 'bg') {
	statusBarToken = token
	refreshStatusBarColor()
}

function refreshStatusBarColor() {
	const channels = getComputedStyle(document.documentElement).getPropertyValue(`--${statusBarToken}`).trim()
	if (!channels) return
	const color = `rgb(${channels.split(/\s+/).join(', ')})`
	document.querySelectorAll('meta[name="theme-color"]').forEach((meta) => meta.setAttribute('content', color))
	// For a native wrapper: match the status bar and launch background to the app (see NATIVE-WRAPPER.md).
	window.dispatchEvent(new CustomEvent('ihh:appearance', { detail: { dark: theme.dark, statusBarColor: color } }))
}

export function installTheme() {
	applyTheme()
	darkQuery?.addEventListener?.('change', (event) => {
		theme.systemDark = event.matches
		refreshStatusBarColor()
	})
	watch(() => theme.preference, applyTheme)
}
